import { Editor } from "@monaco-editor/react";
import {
  Box,
  Button,
  FormHelperText,
  Stack,
  TextareaAutosize,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

export default function CoreJsonEditor({
  value = {},
  onSubmit,
  height = "250px",
}) {
  const editorRef = useRef(null);

  const [localValue, setLocalValue] = useState(value);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (value) {
      setLocalValue(JSON.stringify(value, null, 2));
    }
  }, [JSON.stringify(value)]);

  const handleEditorDidMount = (editor) => {
    editorRef.current = editor;
  };

  const handleSave = () => {
    try {
      onSubmit(JSON.parse(localValue));
      setError(null);
    } catch (err) {
      setError("Wrong JSON format.");
    }
  };

  return (
    <Box>
      <Box
        sx={{
          overflow: "hidden",
          border: "1px solid #ccc",
        }}
      >
        <TextareaAutosize
          onChange={(e) => {
            setLocalValue(e.target.value);
          }}
          value={localValue}
          minRows={20}
          style={{ width: "100%" }}
        />
      </Box>
      {error && (
        <FormHelperText error sx={{ mt: 1 }}>
          {error}
        </FormHelperText>
      )}

      <Stack direction="row" justifyContent="flex-end" mt={2}>
        <Button variant="contained" onClick={handleSave}>
          Submit
        </Button>
      </Stack>
    </Box>
  );
}
